import { MaskedText } from "./components/MaskedText";
import { MaskedTextInput } from "./components/MaskedTextInput";

import { mask, unMask } from "./utils/mask";

export { MaskedText, MaskedTextInput, mask, unMask };
